import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AdjustTimeService {
  constructor(private datePipe: DatePipe) {}

  updateTime(timeZone: string) {
    const displayTz = timeZone;

    const date = moment(new Date()).utc();

    // const time: any = moment(new Date()).tz(timeZone);
    const time = this.toTimeZone(date, timeZone);
    // const times = time.format('HHmm');
    if (time.time > '1500') {
      let d: any = new Date(time.date).setDate(
        new Date(time.date).getDate() + 1
      );
      const tomorrowDate = this.datePipe.transform(d, 'yyyy-MM-dd');
      return tomorrowDate;
    } else {
      return time.date;
    }
  }

  toTimeZone(time, zone) {
    var format = 'YYYY-MM-DD';
    return {
      date: moment(time, format).tz(zone).format(format),
      time: moment(time, format).tz(zone).format('HHmm'),
    };
  }
}
